import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { Container, Card, Table, Button, Alert, Form } from 'react-bootstrap';
import { faPlus, faEdit, faTrash, faExclamationTriangle, faBroom, faFilter } from '@fortawesome/free-solid-svg-icons';
import ActionIcon from 'src/components/general/ActionIcon';
import PageTitle from 'src/components/general/PageTitle';
import AppLoading from 'src/components/common/AppLoading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getHolidayListData, getHolidayListIsFetching, getHolidayDeleteIsFetching } from 'src/redux/holiday/holidayReducer';
import { tryGetHolidayList, tryDeleteHoliday } from 'src/redux/holiday/holidayActionCreator';
import { clearHolidayList, setHolidayToEdit } from 'src/redux/holiday/holidayActions';
import { isNotEmptyArray } from 'src/services/validationService';
import { push } from 'connected-react-router';
import { HOLIDAY_NEW, HOLIDAY_EDIT } from 'src/utils/constants';
import { getClearObject, dateNeutralFormatedToShowARG } from 'src/utils/utils';
import RCPagination from 'src/components/common/RCPagination';

const HolidayListPage = () => {

    const dispatch = useDispatch();
    const { handleSubmit, register, reset } = useForm();

    const holidayListingData = useSelector(state => getHolidayListData(state));
    const holidayIsFetching = useSelector(state => getHolidayListIsFetching(state));
    const deleteHolidayIsFetching = useSelector(state => getHolidayDeleteIsFetching(state))
    const holidayListArrayRecords = holidayListingData?.records;
    const holidayListPaginate = useSelector(state => getHolidayListData(state)?.metadata);

    const hasListHoliday = isNotEmptyArray(holidayListArrayRecords);
    const [filter, setFilter] = useState({});

    //Pagination

    const [pageNumber, setPageNumber] = useState(0);
    const totalCount = holidayListPaginate?.filteredCount;
    const totalItems = holidayListPaginate?.total;

    const defaultParams = {
        page: 0,
        size: 10,
        sort: 'date,desc'
    }

    const fetchList = (params) => {
        dispatch(clearHolidayList());
        dispatch(tryGetHolidayList(params)).then((response) => {
            setPageNumber(response?.metadata?.page || 0);
        });
    };

    const onSubmitForm = (data) => {
        let newFilterObject = {
            ...data,
            ...defaultParams
        };
        const cleanFilterObject = getClearObject(newFilterObject);
        setFilter(cleanFilterObject);
        fetchList(cleanFilterObject);
    };

    const onPageChange = (pNumber) => {
        const params = {
            ...defaultParams,
            ...filter,
            page: pNumber - 1
        };
        fetchList(params);
    };

    const onClickDelete = holiday => {
        swal({
            title: 'Confirmar eliminación',
            text: '¿ ' + 'Realmente deseas eliminar el Feriado: ' + holiday?.name + '?',
            icon: 'warning',
            buttons: ["Cancelar", "Aceptar"],
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    dispatch(tryDeleteHoliday(holiday?.id)).then(
                        response => {
                            if (response?.status == 200) {
                                fetchList(defaultParams);
                            }
                        }
                    );
                }
            });
    };

    const onClickEdit = holiday => {
        dispatch(setHolidayToEdit(holiday));
        dispatch(push(HOLIDAY_EDIT));
    };

    const clearFilters = () => {
        reset();
        setFilter({});
        fetchList(defaultParams);
    };

    useEffect(() => {
        fetchList(defaultParams);
    }, []);

    return <Container fluid className='mb-5'>
        <Card>
            <PageTitle text='Feriados' />
            <Container fluid>
                <Card className='mb-3 '>
                    <Card.Body>
                        <Button size='sm' className='mb-3 btn-success' variant='secondary' onClick={() => dispatch(push(HOLIDAY_NEW))}>
                            <FontAwesomeIcon icon={faPlus} className='mr-1' />
                            Nuevo Feriado
                        </Button>
                        <Form onSubmit={handleSubmit(onSubmitForm)} autoComplete='off'>
                            <Table striped bordered hover size='sm'>
                                <thead>
                                    <tr>
                                        <th className='text-center align-middle' width="15%">Fecha</th>
                                        <th className='text-center align-middle' width="60%">Nombre</th>
                                        <th className='text-center align-middle' width="15%">Tipo</th>
                                        <th className='text-center align-middle th-minwidth' width="10%">Acciones</th>
                                    </tr>
                                    <tr className='secondary'>
                                        <th className='text-center' colSpan='1'>
                                            <Form.Control
                                                name="date"
                                                className='text-center'
                                                size='sm'
                                                type='date'
                                                ref={register}
                                            />
                                        </th>
                                        <th className='text-center' colSpan='1'>
                                            <Form.Control
                                                size='sm'
                                                type='text'
                                                maxLength='250'
                                                name='name'
                                                ref={register}
                                                className='text-center'
                                                placeholder='Nombre del feriado'
                                            />
                                        </th>
                                        <th className='text-center' colSpan='1'>
                                        </th>
                                        <th className='text-center align-middle'>
                                            <div className='d-flex justify-content-around'>
                                                <ActionIcon
                                                    size="lg"
                                                    id="search-button"
                                                    className="btn-primary search-button text-white-color"
                                                    toolTipText="Filtrar"
                                                    icon={faFilter}
                                                    type='submit'
                                                    onSubmit={onSubmitForm}
                                                />
                                                <ActionIcon
                                                    size="lg"
                                                    id="clean-filter"
                                                    className="btn-primary clean-filter text-white-color"
                                                    toolTipText="Limpiar filtros"
                                                    icon={faBroom}
                                                    type='reset'
                                                    onClick={() => clearFilters()}
                                                />
                                            </div>
                                        </th>
                                    </tr>
                                </thead>

                                <tbody className='text-black-color'>
                                    {
                                        hasListHoliday ?
                                            holidayListArrayRecords?.map(holiday =>
                                                <tr key={holiday?.id}>
                                                    <td className='text-center'>
                                                        {dateNeutralFormatedToShowARG(holiday?.date)}
                                                    </td>
                                                    <td className='text-center'>
                                                        {holiday?.name}
                                                    </td>
                                                    <td className='text-center'>
                                                        {holiday?.holidayType?.name}
                                                    </td>
                                                    <td className='d-flex justify-content-around'>
                                                        <div className='col-4'>
                                                            <ActionIcon
                                                                size='lg'
                                                                id='search'
                                                                toolTipText='Editar'
                                                                icon={faEdit}
                                                                onClick={() => onClickEdit(holiday)}
                                                            />
                                                        </div>
                                                        <div className='col-4'>
                                                            <ActionIcon
                                                                size='lg'
                                                                id='delete'
                                                                toolTipText='Borrar'
                                                                icon={faTrash}
                                                                onClick={() => onClickDelete(holiday)}
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>)
                                            :
                                            <tr>
                                                <td colSpan='10' className='text-center'>
                                                    {
                                                        !holidayIsFetching &&
                                                        <Alert variant='info' className='mb-0'>
                                                            <FontAwesomeIcon icon={faExclamationTriangle} className='text-black-color mr-3' />
                                                            No hay feriados para mostrar.
                                                        </Alert>
                                                    }
                                                </td>
                                            </tr>
                                    }
                                </tbody>
                            </Table>
                        </Form>
                        {
                            hasListHoliday &&
                            <RCPagination
                                activePage={pageNumber + 1}
                                itemsCountPerPage={defaultParams?.size}
                                totalItemsCount={totalCount}
                                totalItems={totalItems}
                                thePage={pageNumber + 1}
                                onChange={onPageChange}
                                innerClass="justify-content-center"
                            />
                        }
                    </Card.Body>
                </Card>
            </Container>
        </Card>
        <AppLoading isLoading={holidayIsFetching || deleteHolidayIsFetching} />
    </Container>;
};

export default HolidayListPage;